import { useState } from "react";
import type { GearItem } from "../../../api/client";

/** The slide-in panel of library items to click into the current list. */
export function QuickListView({ shown, items, usedItemIds, onAdd }: { shown: boolean; items: GearItem[]; usedItemIds: Set<string>; onAdd: (itemId: string) => void }) {
  const [term, setTerm] = useState("");
  const t = term.toLowerCase();
  const visible = items.filter((i) => !t || i.name.toLowerCase().includes(t) || i.description.toLowerCase().includes(t) || i.category.toLowerCase().includes(t));
  return (
    <div className={`QuickListView ${shown ? "quickListShowing" : ""}`} style={{ position: "absolute", top: 0, bottom: 25, left: 0, display: shown ? "inline-block" : "none", width: shown ? 200 : 0 }}>
      <div className="searchBar">
        <input type="search" placeholder="Search" aria-label="Search library" value={term} onChange={(e) => setTerm(e.target.value)} />
      </div>
      <div className="itemHolder" style={{ height: "calc(100% - 40px)" }}>
        <ul>
          {visible.map((item) => (
            <li key={item.id} onClick={() => onAdd(item.id)} title={item.name}>
              <div className="addButton">+</div>
              <div className="quicklistContent">
                {item.description ? (
                  <>
                    <div className="quicklistName">{item.name}</div>
                    <div className="quicklistDescription">{item.description}</div>
                  </>
                ) : (
                  <div className="quicklistName singleItem">{item.name}</div>
                )}
              </div>
              {usedItemIds.has(item.id) && <div className="itemUsed">.</div>}
            </li>
          ))}
        </ul>
      </div>
      <hr className="bottomLine" />
    </div>
  );
}
